import { contarPaquetesDelMes } from "../firebase/firestore/paquetes";
import { countUsuariosWeb } from "../firebase/firestore/usuarios";
import { Agency } from "../interfaces/Agency";

// Devuelve false si la cantidad de paquetes creados en el mes supera el limite del plan
const validateCreditsAgency = async (agency: Agency | null) => {
    if (!agency) return false;

    // Si el limite es cero puede crear
    if(!agency.suscripcion.limite) return true;

    const cantidadActual = await contarPaquetesDelMes();

    if (agency.suscripcion.limite <= cantidadActual) {
        return false
    } else { 
        return true
    }
};

const validateHasRates = (agency: Agency | null) => {
    if (!agency || !agency.tarifas) return false;
    
    return !!agency.tarifas.length
}

// Devuelve false si ya se alcanzo el limite de usuarios creables desde la web
const validateWebUserLimit = async (agency: Agency | null) => {
    if (!agency) return false;

    const limite = Number(agency.webUserLimit) || 0;

    // Si el limite es cero (o no esta configurado) puede crear
    if (!limite) return true;

    const cantidadActual = await countUsuariosWeb();

    return cantidadActual < limite;
};

export {
    validateCreditsAgency,
    validateHasRates,
    validateWebUserLimit
};